import React from 'react';
import { graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { GET_EXHIBITOR_DETAILS } from '../graphql/index';
// Components
import ExhibitorDetails from '../components/screens/exhibitors/ExhibitorDetails';
import LoadingPage from '../components/layout/loadingPage/LoadingPage';


const withData = graphql(GET_EXHIBITOR_DETAILS, {
  options: ({ id }) => {
    return {
      variables: {
        id,
      },
    };
  },
  // eslint-disable-next-line no-unused-vars
  props: ({ ownProps, data }) => {
    const { loading, exhibitor } = data;
    return { loading, exhibitorDetails: exhibitor };
  },
});

const mapStateToProps = (state) => {
  return {
    locale: state.localeSelector,
  };
};

const withLoader = (props) => {
  const result = props.loading // eslint-disable-line react/prop-types
  ? <LoadingPage />
  : <ExhibitorDetails {...props} />;

  return <span>{result}</span>;
};

const ContainerWithData = withData(withLoader);
const ExhibitorDetailsContainer = connect(mapStateToProps)(ContainerWithData);

export default ExhibitorDetailsContainer;



/** WEBPACK FOOTER **
 ** ./src/containers/ExhibitorDetailsContainer.js
 **/